import React from "react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {type ISnackbarController} from "views/components/snackbar/snackbar.controller";
import {Snackbar as MuiSnackbar, IconButton, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styled from "@emotion/styled";

const Content = styled.div`
	padding: 4px 8px 4px 16px;
	gap: 8px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: var(--secondaryColor);
	color: #1c1c1e;
	max-width: 320px;
	width: 90%;
	span {
		line-height: 1;
	}
`;

export const Snackbar: React.FC = observer(() => {
	const {isOpen, handleClose, message, callback} = useViewController<ISnackbarController>(
		Bindings.SnackbarController
	);

	return (
		<MuiSnackbar
			open={isOpen}
			autoHideDuration={10000}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "center",
			}}
			onClose={handleClose}>
			<Content onClick={callback}>
				<Typography variant={"body2"} fontWeight={"regular"} component={"span"}>
					{message}
				</Typography>
				<IconButton
					size="small"
					aria-label="close"
					color="inherit"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						handleClose();
					}}>
					<CloseIcon fontSize="small" />
				</IconButton>
			</Content>
		</MuiSnackbar>
	);
});
